"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Occ__ButtonLabel = exports.Occ__Button = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _templateObject, _templateObject2, _templateObject3;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var rippleEffect = (0, _styledComponents.keyframes)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    from {\n        opacity: 1;\n        transform: scale(0);\n    }\n    to {\n        opacity: 0;\n        transform: scale(10);\n    }\n"])));
var Occ__Button = (0, _styledComponents["default"])('button')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    position: relative;\n    overflow: hidden;\n    width: 100%;\n    cursor: pointer;\n    font-family: var(--font-family-primary);\n    font-weight: var(--font-weight-extrabold);\n    line-height: var(--line-height-snug);\n    text-align: center;\n    transition: background 0.3s, border-color 0.3s;\n    color: ", ";\n    max-width: ", ";\n    background: ", ";\n    border: ", ";\n    border-radius: var(--border-radius-sm);\n    padding: ", ";\n    border-color: ", ";\n    text-decoration: ", ";\n    box-shadow: ", ";\n\n    &:focus {\n        outline: ", ";\n        outline-offset: 2px;\n\n        background: ", ";\n        border-color: ", ";\n\n        &::after {\n            display: block;\n        }\n    }\n\n    &:active {\n        filter: brightness(0.9);\n\n        &::after {\n            display: block;\n        }\n    }\n\n    &::after {\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        display: none;\n        width: 100px;\n        height: 100px;\n        margin-top: -50px;\n        margin-left: -50px;\n        animation: ", " 0.8s;\n        background-color: var(--color-base-white);\n        border-radius: var(--border-radius-full);\n        content: '';\n        opacity: 0;\n    }\n\n    &:hover {\n        background: ", ";\n        border-color: ", ";\n    }\n"])), function (props) {
  if (props.color === 'primary' && props.buttonType === 'outline') {
    return 'var(--color-primary)';
  } else if (props.color === 'secondary' && props.buttonType === 'outline') {
    return 'var(--color-secondary)';
  } else if (props.color === 'red' && props.buttonType === 'outline') {
    return 'var(--color-red-600)';
  } else if (props.color === 'primary' && props.buttonType === 'text') {
    return 'var(--color-primary)';
  } else if (props.color === 'secondary' && props.buttonType === 'text') {
    return 'var(--color-secondary)';
  } else if (props.color === 'red' && props.buttonType === 'text') {
    return 'var(--color-red-600)';
  } else if (props.color === 'black' && props.buttonType === 'text') {
    return 'var(--color-base-black)';
  } else if (props.color === 'white' && props.buttonType === 'normal') {
    return 'var(--color-font-muted)';
  } else {
    return 'var(--color-base-white)';
  }
}, function (props) {
  if (props.size === 'large') {
    return '300px';
  } else if (props.size === 'medium') {
    return '150px';
  } else if (props.size === 'small') {
    return '100px';
  } else {
    return '100%';
  }
}, function (props) {
  if (props.color === 'primary' && props.buttonType === 'normal') {
    return 'var(--color-primary)';
  } else if (props.color === 'secondary' && props.buttonType === 'normal') {
    return 'var(--color-secondary)';
  } else if (props.buttonType === 'outline') {
    return 'var(--color-base-white)';
  } else if (props.buttonType === 'normal' && props.color === 'red') {
    return 'var(--color-red-600)';
  } else if (props.buttonType === 'disabled') {
    return 'var(--color-gray-400)';
  } else if (props.color === 'white' && props.buttonType === 'normal') {
    return 'var(--color-base-white)';
  } else if (props.color === 'green' && props.buttonType === 'normal') {
    return 'var(--color-brand-fun-green)';
  } else {
    return 'var(--color-base-white)';
  }
}, function (props) {
  return props.buttonType === 'normal' || props.buttonType === 'outline' ? 'var(--border-width-thick) solid transparent' : props.buttonType === 'disabled' ? 'var(--border-width-none)' : props.buttonType === 'text' ? 'var(--border-width-none)' : 'var(--border-width-none)';
}, function (props) {
  if (props.buttonType === 'normal' || props.buttonType === 'outline' || props.buttonType === 'disabled') {
    return 'var(--spacing-xs)';
  }
}, function (props) {
  if (props.color === 'primary' && (props.buttonType === 'outline' || props.buttonType === 'normal')) {
    return 'var(--color-primary)';
  } else if (props.color === 'secondary' && (props.buttonType === 'outline' || props.buttonType === 'normal')) {
    return 'var(--color-secondary)';
  } else if (props.color === 'red' && props.buttonType === 'normal' || props.buttonType === 'outline') {
    return 'var(--color-red-600)';
  }
}, function (props) {
  return props.underline ? 'underline' : 'none';
}, function (props) {
  return props.color === 'white' ? 'var(--box-shadow-lg)' : 'none';
}, function (props) {
  if (props.color === 'primary' && props.buttonType !== 'disabled') {
    return '2px solid var(--color-primary)';
  } else if (props.color === 'secondary') {
    return '2px solid var(--color-secondary)';
  } else if (props.color === 'red') {
    return '2px solid var(--color-red-600)';
  } else if (props.color === 'primary' && props.buttonType === 'disabled') {
    return '2px solid var(--color-gray-400)';
  } else if (props.color === 'black') {
    return '2px solid var(--color-base-black)';
  }
}, function (props) {
  if (props.buttonType === 'normal' && props.color === 'primary') {
    return 'var(--color-primary-highlight)';
  } else if (props.buttonType === 'normal' && props.color === 'secondary') {
    return 'var(--color-secondary-highlight)';
  }
}, function (props) {
  if (props.buttonType === 'normal' && props.color === 'primary') {
    return 'var(--color-primary-highlight)';
  } else if (props.buttonType === 'normal' && props.color === 'secondary') {
    return 'var(--color-secondary-highlight)';
  }
}, rippleEffect, function (props) {
  if (props.buttonType === 'normal' && props.color === 'primary') {
    return 'var(--color-primary-highlight)';
  } else if (props.buttonType === 'normal' && props.color === 'secondary') {
    return 'var(--color-secondary-highlight)';
  }
}, function (props) {
  if (props.buttonType === 'normal' && props.color === 'primary') {
    return 'var(--color-primary-highlight)';
  } else if (props.buttonType === 'normal' && props.color === 'secondary') {
    return 'var(--color-secondary-highlight)';
  }
});
exports.Occ__Button = Occ__Button;
var Occ__ButtonLabel = (0, _styledComponents["default"])('span')(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    font-size: ", ";\n"])), function (props) {
  if (props.textSize === 'base') {
    return 'var(--font-size-base)';
  } else if (props.textSize === 'xxs') {
    return 'var(--font-size-xxs)';
  } else if (props.textSize === 'xs') {
    return 'var(--font-size-xs)';
  } else if (props.textSize === 'sm') {
    return 'var(--font-size-sm)';
  } else if (props.textSize === 'md') {
    return 'var(--font-size-md)';
  } else if (props.textSize === 'lg') {
    return 'var(--font-size-lg)';
  } else if (props.textSize === 'xl') {
    return 'var(--font-size-xl)';
  } else if (props.textSize === 'xxl') {
    return 'var(--font-size-xxl)';
  } else if (props.textSize === 'xxxl') {
    return 'var(--font-size-xxxl)';
  } else if (props.textSize === 'xxxxl') {
    return 'var(--font-size-xxxxl)';
  } else {
    return 'var(--font-size-xs)';
  }
});
exports.Occ__ButtonLabel = Occ__ButtonLabel;